import React from "react";
import styles from "./EventTable.module.css";
import Markdown from "markdown-to-jsx";
import { useRouter } from "next/navigation";
import { AiOutlineRight } from "react-icons/ai";
const EventTable = ({ link }) => {
  const router = useRouter();
  const handleButtonClick = () => {
    if (link && link !== "") {
      if (!/^https?:\/\//i.test(link)) {
        link = "https://" + link;
      }
      window.open(link, "_blank");
    }
  };
  return (
    <div className={styles.description_wrap}>
      <h2 style={{ fontSize: "24px" }}>Table Request</h2>
      <button onClick={handleButtonClick}>
        Book &nbsp; <AiOutlineRight color="#93364f" />
      </button>
    </div>
  );
};

export default EventTable;
